require('./hireCardECardSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ constants
const { ACCIDENTS_INSURANCE } = require('constants/flagBasedFeatures');
const { analyticsId, catalogue } = require('../analytics/hireCardECardAnalytics');

class hireCardECardSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
        } = this.props;
        let accountIban;
        let alias;

        if (!!immAccount) {
            accountIban = !!immAccount.get('iban') && getLastNChars(immAccount.get('iban'));
            alias = !!immAccount.get('alias') && immAccount.get('alias');
        }

        return (
            <div className="row hire-card-ecard-success__summary">
                <div className="col-xs-6">
                    <FormattedText
                        className="col-xs-12 hire-card-ecard-success__summary-title"
                        value="hireCardECard-summarySelectedName"
                    />
                    <div className="col-xs-12 hire-card-ecard-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <FormattedText
                        className="col-xs-12 hire-card-ecard-success__summary-title"
                        value="hireCardECard-summarySelectedAccount"
                    />
                    <div className="col-xs-12 hire-card-ecard-success__summary-value">
                        {alias} {accountIban}
                    </div>
                </div>
            </div>
        );
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        let text = 'hireCardECard-successWarningTextUpdateEmail';
        let injectedString = [];

        if (!!email) {
            text = 'hireCardECard-successWarningTextSentByEmail';
            injectedString = [email];
        }

        return (
            <div className="hire-card-ecard-success__message">
                <OKMessage type="informative">
                    <FormattedText value={text} injectedStrings={injectedString} />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardECard,
            immHireCardImageSelector,
            immProfile,
            downloadECard,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardECard-successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };
            const url = formatText('hireCardECard-successWarningUrl2');
            let messageContent;

            if (immHireCardECard.get('pdfDownloadError')) {
                messageContent = (
                    <div className="hire-card-ecard-success__message">
                        <OKMessage type="warning">
                            <FormattedText value="hireCardECard-pdfDownloadError" />
                        </OKMessage>
                    </div>
                );
            }

            content = (
                <WizardSuccess
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText('hireCardECard-successTitle')}
                    tealium={catalogue[analyticsId.ECOMMERCE_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-ecard-success">
                        <div className="row">
                            <div className="col-xs-5">
                                <HireSuccessStepCardImage
                                    className="hire-card-ecard-success__card-image"
                                    immImageData={immImageData}
                                />
                            </div>
                            <div className="col-xs-7">
                                <div className="hire-card-ecard-success__text">
                                    <FormattedText value="hireCardECard-successMessageTextECard" />
                                </div>
                                <OKButton modifier="secondary" size="regular" onClick={downloadECard}>
                                    <FormattedText
                                        value="hireCardECard-pdfButton"
                                    />
                                </OKButton>
                                {messageContent}
                            </div>
                        </div>
                        {summarySection}
                        <FeatureTogglingRender notAllowedProductKey={ACCIDENTS_INSURANCE} >
                            <div className="hire-card-ecard-success__message">
                                <OKMessage type="informative">
                                    <FormattedText value="hireCardECard-successWarningText1" />
                                    &nbsp;
                                    <OKLink modifier="inline" target="_blank" to={url}>
                                        <FormattedText value="hireCardECard-successWarningText2" />
                                    </OKLink>
                                    &nbsp;
                                    <FormattedText value="hireCardECard-successWarningText3" />
                                </OKMessage>
                            </div>
                        </FeatureTogglingRender>
                        {messageSection}
                    </article>
                </WizardSuccess>
            );
        }

        return content
    }
}

hireCardECardSuccess.propTypes = {
    downloadECard: PropTypes.func.isRequired,
    immAccount: PropTypes.object.isRequired,
    immHireCardECard: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = hireCardECardSuccess;
